export const environment = {
  production: true,
  apiUrl: 'https://dispatch-service-prod.fly.dev',
  wsUrl: 'wss://dispatch-service-prod.fly.dev/ws',
  backendClientId: 'e4ec9c37-a543-4bda-96dd-28bd8eff3bcf',
  azureTenantId: '49f2c8ba-9f13-4d85-bdaa-187e1254a197'
}; 